
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ItemChip from "@/components/common/ItemChip.vue";
  import ItemChipsData from '@/entities/ItemChipsData';
  import {NO_INFORMATION} from '@/data/placeholders';

  @Component({
    components: {
      ItemChip,
    },
  })
  export default class ItemChipsWithMore extends Vue {
    @Prop({type: Array, required: true }) readonly items!: ItemChipsData[];
    @Prop({default: 3, type: Number}) readonly limit!: number;
    @Prop({default: undefined, type: Object}) readonly navigateTo!: object;
    @Prop({ type: String, default: undefined }) readonly routeName?: string;
    @Prop({type: Boolean, default: false}) readonly isPerson!: boolean;
    @Prop({type: Boolean, default: true}) readonly showNotAvailable!: boolean;
    @Prop({type: Number, default: undefined}) readonly moreNumber?: number;
    @Prop({type: String, default: undefined}) readonly maxChipWidth?: string;
    @Prop({type: String, default: "font-semibold text-sm -mb-1.5" }) readonly noContentClasses!: string;
    @Prop({type: String, default: undefined }) readonly textClasses?: string;
    @Prop({type: Boolean, default: false, required: false}) readonly management!: boolean;

    get noContent(): boolean {
      return !this.items.length;
    }

    get noContentPlaceholder(): string {
      return this.showNotAvailable ? NO_INFORMATION : '';
    }

    get itemsToRender(): ItemChipsData[] {
      return this.items.slice(0, this.limit);
    }

    get itemsMoreThanLimit(): boolean {
      if (this.moreNumber) {
        return this.moreNumber > this.limit;
      }
      return this.items.length > this.limit;
    }

    get alignmentClass(): string {
      return this.noContent ? "items-baseline" : "items-center";
    }

    get moreLinkNumber(): number {
      if (!this.moreNumber) {
        return this.items.length - this.limit;
      }
      return this.moreNumber - this.limit;
    }

    get containerClasses(): Record<string, boolean> {
      return {
        ["bg-greenChip text-lightGreen"]: this.management,
        ["bg-lightBlue text-darkBlue"]: !this.management,
      }
    }
  }
